import { render } from "./Join.vue?vue&type=template&id=3e32890f&scoped=true&ts=true"
import script from "./Join.vue?vue&type=script&lang=ts"
export * from "./Join.vue?vue&type=script&lang=ts"

import "./Join.vue?vue&type=style&index=0&id=3e32890f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e32890f"]])

export default __exports__